<template>
    <div class="loading-screen">
        <div class="loading-div">
            <font-awesome-icon icon="spinner" class="loading" />
        </div>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { faSpinner } from '@fortawesome/free-solid-svg-icons'

    library.add(faSpinner);

    export default {
        name: "loading-screen",
        data() {
            return {

            }
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<style scoped>
    @import "./loading-screen.scss";
</style>


// WEBPACK FOOTER //
// src/components/LoadingScreen/LoadingScreen.vue